import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import { EconomicCard } from "../../components/economic-card.component";
import { UIInput } from "../../components/ui-input";
import { useNavigate, Link } from "react-router-dom";
import { RegistrationHeader } from "../../components/registeration-header-.component";
import { useForgetPassword } from "../../hooks/useForgetPassword.js";
import { getItem } from "../../helper/localstorage.helper";
import "../../scss/forget-password.scss";

export const ForgetPassword: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const language = getItem("i18nextLng");


    const {
        formData,
        errors,
        submitError,
        isSubmitting,
        isSuccess,
        handleInputChange,
        handleSubmit,
    } = useForgetPassword({
        // onSuccess: () => {
        //     const url = language === 'en-us'
        //         ? `/emaillogin?lang=en-us`
        //         : `/e-postinloggning?lang=sv-se`;
        //     navigate(url);

        // },
        onError: (error: string) => {
            console.error('Forget password error:', error);
        },
    });

    function handleNavigate() {
        return language === 'en-us' ? '/emaillogin?lang=en-us' : '/e-postinloggning?lang=sv-se';
    }
    return (
        <div className="forget-password-page">
            <RegistrationHeader />
            <Container className="forget-password-container">
                <Row className="px-0 ">
                    <Col sm={12} md={6} className="px-0 pr-3 d-sm-flex justify-content-sm-start align-items-sm-center">
                        <div className="forget-password-form-wrapper">
                            <h1 className="forget-password-title">{t("FORGET_PASSWORD_TITLE")}</h1>

                            <div>
                                <p className="forget-password-description">
                                    {t("FORGET_PASSWORD_DESCRIPTION")}
                                </p>

                                <form className="forget-password-form" onSubmit={handleSubmit}>
                                    <UIInput
                                        type="email"
                                        label={t("REGISTRATION_EMAIL_LABEL")}
                                        placeholder={t("REGISTRATION_EMAIL_PLACEHOLDER")}
                                        value={formData.email}
                                        onChange={(e) => handleInputChange(e.target.value)}
                                        error={!!errors.email}
                                        errorMessage={errors.email}
                                        required={true}
                                    />
                                    <button type="submit" className="forget-password-submit-btn" disabled={isSubmitting}>
                                        {isSubmitting ? t("SENDING") : t("FORGET_PASSWORD_BUTTON")}
                                    </button>
                                </form>

                                <div className="forget-password-back-link">
                                    <Link to={handleNavigate()} className="pt-4">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={14}
                                            height={12}
                                            viewBox="0 0 14 12"
                                            fill="none"
                                        >
                                            <path
                                                d="M12.8332 6H1.99987M6.16654 1L1.7558 5.41074C1.43036 5.73618 1.43036 6.26382 1.7558 6.58926L6.16654 11"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                        {t("BACK_TO_LOGIN")}
                                    </Link>
                                </div>
                                <div className="forget-password-trustpilot d-none d-sm-block">
                                    <div className="trustpilot-widget" data-locale="sv-SE" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="64f712e3dbd20bbfcf3a825f" data-style-height="24px" data-style-width="100%">
                                        <a href="https://se.trustpilot.com/review/invozio.com" target="_blank" rel="noopener">Trustpilot</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} md={6} className="px-0 d-none d-md-block">
                        <EconomicCard />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ForgetPassword;
